import { isCategory } from 'utils/category';
import { PRODUCT_CARD_MODE } from 'components/ProductCard/ProductCard.utils';

export const getInGridElementsMode = productCardMode => {
    let resultMode = 'grid';
    if (
        [PRODUCT_CARD_MODE.LIST, PRODUCT_CARD_MODE.LIST_SPEC].includes(
            productCardMode,
        )
    ) {
        resultMode = 'list';
    }
    return resultMode;
};

export const getSponsoredProductData = (
    productId = '',
    sponsoredProducts = {},
) => {
    const { adsInfo = [] } = sponsoredProducts;
    const sponsoredProduct = adsInfo.find(
        ad => `${ad.product_id}` === productId,
    );

    return {
        status: !!sponsoredProduct,
        // eslint-disable-next-line camelcase
        id: sponsoredProduct?.ad_tracking_data,
    };
};

export const getSponsoredProductDisplayed = (
    products = [],
    sponsoredProducts = {},
) => {
    const { adsInfo = [] } = sponsoredProducts;
    return adsInfo
        .map(sponsored => ({
            product: sponsored,
            position:
                products.findIndex(
                    ({ objectID }) =>
                        sponsored.product_id === parseInt(objectID, 10),
                ) + 1,
        }))
        .filter(({ position }) => position > 0);
};

export const isPromotedProduct = (product = {}, categoryId, options = {}) => {
    const { landingProductModelId, featureFlags = {} } = options;
    const { hasAlternateEngine = false } = featureFlags;
    const bannerKey = hasAlternateEngine ? 'banner.alternate' : 'banner';
    return (
        (!landingProductModelId &&
            product[bannerKey] &&
            product[bannerKey].categories &&
            product[bannerKey].categories.includes(`topSales.${categoryId}`)) ||
        product.model_id === parseInt(landingProductModelId, 10)
    );
};

const findAndSeparatePromotedProductFromProducts = ({
    products,
    category,
    hasAlternateEngine,
    landingProductModelId,
}) => {
    const promotedProduct = products.find(product =>
        isPromotedProduct(product, category.id, {
            featureFlags: { hasAlternateEngine },
            landingProductModelId,
        }),
    );
    const promotedProductIndex = products.indexOf(promotedProduct);
    const resultProducts = [...products];
    if (promotedProductIndex > -1) {
        resultProducts.splice(promotedProductIndex, 1);
    }
    return [promotedProduct, resultProducts];
};

export const separatePromotedProductAndOtherProducts = (
    products = [],
    options = {},
) => {
    const {
        hasAlternateEngine = false,
        category,
        landingProductModelId,
        showPromotedProduct = false,
    } = options;

    if (!showPromotedProduct || !isCategory(category)) {
        return [undefined, products];
    }

    if (
        isPromotedProduct(products[0], category.id, {
            featureFlags: { hasAlternateEngine },
            landingProductModelId,
        })
    ) {
        const [promotedProduct, ...otherProducts] = products;
        return [promotedProduct, otherProducts];
    }

    return findAndSeparatePromotedProductFromProducts({
        products,
        category,
        hasAlternateEngine,
        landingProductModelId,
    });
};

export const isNewProductCard = ({
    isB2BUser,
    hasB2BProductCardRedesign,
    hasB2B,
}) => (isB2BUser && hasB2B && hasB2BProductCardRedesign) || !isB2BUser;
